// extracted by mini-css-extract-plugin
module.exports = {"close_img":"WechatLogin_close_img__3Yece","qrcode":"WechatLogin_qrcode__2esB5"};